import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQItem = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <Card 
      className="bg-gradient-to-br from-[#1a1a1a] to-[#151515] border-gray-800 hover:border-[#2F6BFF]/50 transition-all duration-300 cursor-pointer"
      onClick={() => setIsOpen(!isOpen)}
    >
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg text-[#F5F7FF]">{item.question}</CardTitle>
          {isOpen ? (
            <ChevronUp className="h-5 w-5 text-[#2F6BFF] flex-shrink-0" />
          ) : (
            <ChevronDown className="h-5 w-5 text-[#2F6BFF] flex-shrink-0" />
          )}
        </div>
      </CardHeader>
      {isOpen && (
        <CardContent>
          <p className="text-[#9AA3B2] leading-relaxed">{item.answer}</p>
        </CardContent>
      )}
    </Card>
  );
};

export default FAQItem;
